export const GB_1 = 1073741824;
